import { render, staticRenderFns } from "./IRCorporateGovernancePage.vue?vue&type=template&id=1c3622d3"
import script from "./IRCorporateGovernancePage.vue?vue&type=script&lang=js"
export * from "./IRCorporateGovernancePage.vue?vue&type=script&lang=js"
import style0 from "./IRCorporateGovernancePage.vue?vue&type=style&index=0&id=1c3622d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports